import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { transportAPIBase } from 'app/utilities/env';

import { TFleet } from '../types/fleet';

export const fleetsApiSlice = createApi({
  reducerPath: 'fleetsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${transportAPIBase}/fleets`,
  }),
  endpoints: (build) => ({
    getFleets: build.query<TFleet[], void>({
      query: () => '',
      transformResponse: (response: TServerResponse<TFleet[]>) => response.data,
    }),
  }),
});

export const { useGetFleetsQuery, useLazyGetFleetsQuery } = fleetsApiSlice;
